<template>
	<div v-if="loading">
		<div class="row">
			<div class="col-12">
				<label class="font28 font500"><i class="fa fa-bullhorn fa-13"></i> จัดการโปรโมชั่น</label>
			</div>
		</div>
		<div class="row mt-3">
			<div class="col-12 col-md-12">
				<!-- <div class="d-flex flex-row mr-5"> -->
				<div class="row">
					<div class="align-self-center ml-3">ค้นหา User</div>
					<div class="col-12 col-md-4 p-2">
						<div class="input-group">
							<div class="input-group-prepend">
								<span class="input-group-text" id="basic-addon">
									<mdb-icon far icon="edit" />
								</span>
							</div>
							<input type="text" class="form-control" v-model="searchTxt" aria-describedby="basic-addon"
								width="80%" />
						</div>
					</div>
					<div class="col-12 col-md-6 py-1">
						<button type="button" class="btn btn-search color_white font12"
							style="font-weight:400; margin-left:-8px" @click="Search()"><i class="fab fa-sistrix"></i>
							Search</button>
						<router-link to="Managepromotionadd">
							<button id="Setuseradd" type="button" class="btn btn-add color_white font12"
								style="font-weight:400;"><i class="fas fa-plus"></i> Add</button>
						</router-link>
						<!-- <button type="button" class="btn btn-cancel color_white font12" style="font-weight:400;"><i class="fas fa-times"></i> Cancel</button> -->
					</div>
				</div>
			</div>
		</div>

		<div>
			<mdb-datatable :arrows="true" :data="data" striped bordered :searching="false" scrollY maxHeight="450px" />
		</div>

		<mdb-container>
			<!-- <mdb-btn color="primary" @click.native="showModal = true">Launch modal</mdb-btn> -->
			<mdb-modal :show="showModal" @close="showModal = false" scrollable centered>
				<mdb-modal-header>
					<mdb-modal-title>
						<mdb-icon icon="fingerprint" /> แก้ไขข้อมูล</mdb-modal-title>
				</mdb-modal-header>
				<mdb-modal-body>
					<div class="row justify-content-center">
						<div class="col-10 col-md-9">
							<!-- <div class="row justify-content-center mt-3">
								<div class="col-5 align-self-center">โปรโมชั่น</div>
								<div class="col-7 pl-0">
									<select class="custom-select custom-select-sm promotion_isssd" v-model="pro_name">
										<option :value="items.pro_name" v-for="items in data.rows" :key="items">{{ items.pro_name }}</option>
									</select>
								</div>
							</div> -->
							<div class="row justify-content-center mt-2">
								<div class="col-5 align-self-center">โปรโมชั่น</div>
								<div class="col-7 pl-0"><input type="text" id="pro_price" v-model="pro_name"
										class="form-control form-control-sm" width="100%" /></div>
							</div>
							<div class="row justify-content-center mt-2">
								<div class="col-5 align-self-center">ราคา</div>
								<div class="col-4 pl-0"><input type="text" id="pro_price" v-model="pro_price"
										class="form-control form-control-sm" width="100%" /></div>
								<div class="col-3 pl-0 align-self-center">บาท</div>
							</div>
							<div class="row justify-content-center mt-2">
								<div class="col-5 align-self-center">จำนวนเครดิตที่ได้</div>
								<div class="col-4 pl-0"><input type="text" id="pro_credit" v-model="pro_credit"
										class="form-control form-control-sm" width="100%" /></div>
								<div class="col-3 pl-0 align-self-center">บาท</div>
							</div>
							<div class="row  mt-2">
								<div class="col-5 align-self-center">อายุการใช้งาน</div>
								<div class="col-3 pl-0"><input type="text" id="expire_date" v-model="expire_date"
										class="form-control form-control-sm" width="100%" /></div>
								<div class="col-4 pl-0 align-self-center">เดือน</div>
							</div>
							<div class="row  mt-2">
								<div class="col-5 align-self-center">ชื่อผู้ส่ง</div>
								<div class="col-3 pl-0"><input type="text" id="expire_date" v-model="amount_sender"
										class="form-control form-control-sm" width="100%" /></div>
								<div class="col-4 pl-0 align-self-center">จำนวน</div>
							</div>
							<div class="row justify-content-center">
								<div class="col-5 align-self-center">สถานะ</div>
								<div class="col-2 pl-0">
									<label class="switch" style="">
										<input type="checkbox" v-model="status" />
										<span class="slider round"></span>
									</label>
								</div>
								<div class="col-5 align-self-center pl-0">ปิด - เปิด</div>
							</div>
							<div class="row justify-content-center">
								<div class="col-5 align-self-center">กลุ่มลูกค้า</div>
								<div class="col-7 pl-0">

									<div class="d-flex">
										<div class="form-check pl-0">
											<input class="form-check-input" type="radio" name="exampleRadios" id="one"
												value="member" v-model="pro_type">
											<label class="mb-0" for="one">member</label>
										</div>
										<div class="form-check">
											<input class="form-check-input" type="radio" name="exampleRadios" id="two"
												value="VIP" v-model="pro_type">
											<label class="mb-0" for="two">VIP</label>
										</div>
									</div>
								</div>
							</div>
							<div class="row justify-content-center">
								<div class="col-12 text-center my-4">
									<button type="button" class="btn btn-search color_white mr-3 font12"
										style="font-weight:400;" @click="editpromotion()">บันทึก</button>
									<button type="button" class="btn btn-cancel color_white font12"
										style="font-weight:400;" @click="editusercancle()">ยกเลิก</button>
								</div>
							</div>
						</div>
					</div>
				</mdb-modal-body>
			</mdb-modal>
		</mdb-container>
	</div>
</template>

<script>
	import $ from 'jquery'
	// import {mdbDatatable} from 'mdbvue'
	// import moment from 'moment'
	import {
		mapGetters,
		mapActions
	} from 'vuex'
	let no = 0
	export default {
		name: 'Managepromotion',
		components: {
			// mdbDatatable,
		},
		data() {
			return {
				loading: false,
				showModal: false,
				searchTxt: '',
				pro_name: '',
				pro_price: '',
				pro_credit: '',
				expire_date: '',
				pro_type: '',
				amount_sender: '',
				status: 0,
				idedituser: 0,
				data: {
					columns: [{
							label: '#',
							field: 'id2',
							sort: true,
							format: (value) => {
								no = value - 1
								return value
							},
						},
						{
							label: '',
							field: 'id',
							sort: true,
							format: (value) => {
								if (value) {
									return '<div class="text-center btnbtn" style="max-width:110px;" dataid="' +
										value +
										'"><label class="bg-file-search text-white font14" style="cursor: pointer;" ><mdb-icon far icon="file-alt" /><i class="fas fa-file-alt fa-13"></i></label></div>'
								}
							},
						},
						{
							label: 'โปรโมชั่น',
							field: 'pro_name',
							sort: true,
							format: (value) => {
								return '<div class="rows" style="min-width:160px;">' + value + '</div>'
							},
						},
						{
							label: 'ราคา',
							field: 'pro_price',
							sort: true,
							format: (value) => {
								return '<div class="rows" style="min-width:70px;">' + value + '</div>'
							},
						},
						{
							label: 'จำนวนเครดิตที่ได้',
							field: 'pro_credit',
							sort: true,
							format: (value) => {
								return '<div class="rows" style="min-width:130px;">' + value + '</div>'
							},
						},
						{
							label: 'อายุการใช้งาน',
							field: 'expire_date',
							sort: true,
							format: (value) => {
								return '<div class="rows" style="min-width:110px;">' + value + ' เตือน</div>'
							},
						},
						{
							label: 'ชื่อผู้ส่ง',
							field: 'amount_sender',
							sort: true,
							format: (value) => {
								if (value == '-') {
									return '<div class="rows" style="min-width:110px;">' + value ?
										'ไม่มีชื่อผู้ส่ง' : value + '</div>'
								} else {
									return '<div class="rows" style="min-width:110px;">' + value +
										' ชื่อผู้ส่ง</div>'
								}
							},
						},
						{
							label: 'สถานะ',
							field: 'status',
							sort: true,
							format: (value) => {
								if (value == 1) {
									return '<div class="rows pl-4 font500" style="min-width:120px;"><label class="switch my-0"><input type="checkbox" checked disabled/><span class="slider round" style="cursor:auto;"></span><span class="btndelete btn-delete text-white" style="margin-left:60px" deleteid="' +
										this.data.rows[no].id +
										'"><i class="fas fa-times"></i></span></label></div>'
								} else {
									return '<div class="rows pl-4 font500" style="min-width:120px;"><label class="switch my-0"><input type="checkbox" disabled/><span class="slider round" style="cursor:auto;"></span><span class="btndelete btn-delete text-white" style="margin-left:60px"  deleteid="' +
										this.data.rows[no].id +
										'"><i class="fas fa-times"></i></span></label></div>'
								}
							},
						},
					],
					rows: null,
				},
			}
		},
		computed: {
			...mapGetters({
				isLogin: 'isLogin',
				user: 'user',
				token: 'token',
			}),
		},
		methods: {
			...mapActions({
				storeLogin: 'login',
				storeLoout: 'logout',
				loadsession: 'loadsession',
				callApiMotherFucker: 'callApiMotherFucker',
			}),
			editusercancle() {
				this.showModal = false
			},
			editpromotion() {
				if (this.pro_name == '' || this.pro_name == null) {
					return this.$swal({
						html: '<i class="fa fa-user-circle fa-6x"></i><br><br>กรุณากรอกชื่อโปรโมชั่น<br>',
						timer: 5000,
						showConfirmButton: true,
						allowOutsideClick: false,
						allowEscapeKey: false,
					})
				}
				if (this.pro_price == '' || this.pro_price == null) {
					return this.$swal({
						icon: 'info',
						html: 'กรุณากรอกราคา<br>',
						timer: 5000,
						showConfirmButton: true,
						allowOutsideClick: false,
						allowEscapeKey: false,
					})
				}
				if (this.pro_credit == '' || this.pro_credit == null) {
					return this.$swal({
						icon: 'info',
						html: 'กรุณากรอกจำนวนเครดิตที่ได้<br>',
						timer: 5000,
						showConfirmButton: true,
						allowOutsideClick: false,
						allowEscapeKey: false,
					})
				}
				if (this.expire_date == '' || this.expire_date == null) {
					return this.$swal({
						icon: 'info',
						html: 'กรุณากรอกอายุการใช้งาน<br>',
						timer: 5000,
						showConfirmButton: true,
						allowOutsideClick: false,
						allowEscapeKey: false,
					})
				}

				this.callApiMotherFucker({
					method: 'post',
					path: '/promotion',
					data: {
						id: this.idedituser,
						pro_name: this.pro_name,
						pro_price: this.pro_price,
						pro_credit: this.pro_credit,
						expire_date: this.expire_date,
						pro_type: this.pro_type,
						amount_sender: this.amount_sender,
						status: this.status ? 1 : 0
					}, // this.status_user ถ้าเป็น 1 คือ true , ถ้าเป็น 0 คือ false
				}).then((res) => {
					console.log('payload', res.payload)
					if (res.code == 0) {
						this.$swal({
							icon: 'success',
							html: res.msg,
							showConfirmButton: true,
							allowOutsideClick: false,
							allowEscapeKey: false,
						}).then((result) => {
							if (result) {
								location.reload()
							}
						})
					} else {
						this.$swal({
							icon: 'error',
							html: res.msg,
							showConfirmButton: true,
							allowOutsideClick: false,
							allowEscapeKey: false,
						})
					}
				})
			},
			async Search() {
				this.loading = false
				if (this.searchTxt == '') {
					await this.callApiMotherFucker({
						method: 'post',
						path: '/list_member/query',
						data: {},
					}).then((res) => {
						if (res.payload) {
							this.data.rows = this.$add_index(res.payload)
							this.loading = true
						}
					})
				} else {
					await this.callApiMotherFucker({
						method: 'post',
						path: '/list_member/query',
						data: {},
					}).then((res) => {
						if (res.payload) {
							this.data.rows = this.$add_index(res.payload)
						}
					})
					this.data.rows = this.data.rows.filter((val) => {
						if (val.pro_name.search(this.searchTxt) >= 0) {
							return true
						} else {
							return false
						}
					})
					this.loading = true
				}
			},
		},
		async mounted() {
			await this.callApiMotherFucker({
				method: 'GET',
				path: '/promotionAll',
				data: {},
			}).then((res) => {
				this.loading = true
				if (res.payload) {
					this.data.rows = this.$add_index(res.payload)
				}
			})

			let edit_detial = this
			$('.btnbtn').on('click', function () {
				let id = $(this).attr('dataid') || 0
				edit_detial.idedituser = id // เอาid มาเก็บไว้ในตัวแปร idedituser เพื่อจะนำไปอัพเดท
				if (id > 0) {
					// this.loading = true
					edit_detial
						.callApiMotherFucker({
							method: 'GET',
							path: '/promotion/' + id,
							data: {
								id: edit_detial.idedituser
							},
						})
						.then((res) => {
							edit_detial.pro_type = res.payload[0].pro_type
							edit_detial.pro_name = res.payload[0].pro_name
							edit_detial.pro_price = res.payload[0].pro_price
							edit_detial.pro_credit = res.payload[0].pro_credit
							edit_detial.expire_date = res.payload[0].expire_date
							edit_detial.amount_sender = res.payload[0].amount_sender
							edit_detial.status = res.payload[0].status
							edit_detial.showModal = true
						})
				}
			})

			let delete_detial = this
			$('.btndelete').on('click', function () {
				let id = $(this).attr('deleteid') || 0
				if (id > 0) {
					this.loading = false
					let payload = {
						id: id, //this.data.rows.id_upload_file,
					}
					delete_detial
						.callApiMotherFucker({
							method: 'DELETE',
							path: '/promotion',
							data: payload,
						})
						.then((res) => {
							delete_detial
								.$swal({
									icon: 'success',
									html: res.msg,
									timer: 8000,
									showConfirmButton: true,
									allowOutsideClick: false,
									allowEscapeKey: false,
								})
								.then((result) => {
									if (result) {
										location.reload()
									}
								})
						})
				}
			})
		},
	}
</script>
<style scoped>
	.fa-13 {
		font-size: 1em;
	}

	.field-icon {
		margin-left: 25px;
		margin-right: 10px;
		margin-top: 0px;
		position: relative;
		z-index: 2;
	}

	.label1 {
		color: red !important;
	}

	.modal-dialog .modal-content .modal-header {
		border-top-left-radius: 0.1rem !important;
		border-top-right-radius: 0.1rem !important;
		background-color: #f5904b !important;
		color: #ffffff;
	}
	.form-check-input[type="radio"]:checked+label:after{
background-color: #f5904b;
}
.form-check-input[type="radio"]:checked+label:after{
border: 2px solid #f5904b;
}
</style>